import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-32 pb-20">
        <div className="w-full px-4 md:px-6 max-w-lg mx-auto text-center">
          <div className="w-20 h-20 mx-auto mb-6 flex items-center justify-center rounded-full bg-background-100">
            <i className="ri-error-warning-line text-3xl text-foreground-400"></i>
          </div>
          <h1 className="font-heading text-4xl font-bold text-foreground-900 mb-4">404</h1>
          <p className="text-base text-foreground-600 mb-8">
            This page could not be found. The article or resource you are looking for may have moved or does not exist.
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-background-50 bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            Back to Home
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}